module.exports = __webpack_public_path__ + "img/fblc-职教赛区.7352d5ec.jpg";